

























































































import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import { parseFloatNumber } from '../utils';

@Component({
    components: {}
})
export default class MapReferences extends Vue {
    @Prop({ default: '' }) scaleType: string;
    @Prop({ default: [] }) scale: any;
    @Prop({
        default() {
            return [];
        }
    })
    panelsList: Array<object>;
    @Prop({ default: null }) workLines: any;
    @Prop({ default: null }) vehicleReferences: any;
    @Prop({ default: null }) calibrationsReferences: any;
    @Prop({ default: null }) mostRepresentativeImage: any;
    @Prop({ default: false }) mostRepresentativeIsActive: boolean;
    colors: Array<string> = [
        '#df1e36', //10
        '#db5c6c', //9,
        '#db7d6c', //8
        '#db9d6c', //7
        '#ecbc59', //6
        '#f9e863', //5
        '#e9f063', //4
        '#c8e063', //3
        '#a7cf63', //2
        '#87bf63', //1
        '#66af63' //0
    ];

    parseNumber(value){
        return parseFloatNumber(value, 2)
    }

    filteredWorkLineReferences(workLines){
        if(workLines === null) return []

        return workLines.filter((workLine) => workLine['sown_area'] > 0)
    }

    mounted() {}
}
